var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveroo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M350.508 0L327.331 220.365L287.818 34.5745L163.198 60.7903L202.331 246.581L23 284.574L54.9149 432.751L370.644 500L442.833 338.526L477.027 13.2979L350.508 0ZM250.584 319.909C244.125 325.988 235.766 325.228 226.267 322.188C217.149 319.149 213.35 308.511 216.389 294.833C219.049 284.954 230.827 283.435 237.286 283.435C239.565 283.435 241.845 283.815 244.125 284.954C248.304 286.854 255.523 291.033 257.043 297.112C259.322 306.231 257.043 313.83 250.584 319.909ZM342.149 329.787C337.21 338.146 325.052 339.286 312.514 333.207C304.155 329.027 304.155 319.149 305.295 312.69C305.675 309.271 307.194 305.851 309.474 303.192C312.514 299.392 317.453 294.453 322.772 294.453C332.27 294.073 339.869 298.252 344.429 305.851C348.988 313.45 346.708 321.809 342.149 329.787Z",
    fill: "#2AE529"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveroo);
export default __webpack_public_path__ + "static/media/deliveroo.987732bf0f2ce6dfd2bf730461ede573.svg";
export { ForwardRef as ReactComponent };